
import { TypographyOptions } from "@mui/material/styles/createTypography";
import { Theme } from "@mui/material";
import { pxToRem } from "utils/formatFont";

interface ResponsiveFontSize {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  theme: Theme;
}

export function responsiveFontSizes({ xs, sm, md, lg, theme }: ResponsiveFontSize) {
  return {
    [theme.breakpoints.up("xs")]: {
      fontSize: pxToRem(xs),
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: pxToRem(sm),
    },
    [theme.breakpoints.up("md")]: {
      fontSize: pxToRem(md),
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: pxToRem(lg),
    },
  };
}

const typography: TypographyOptions = {
  fontFamily:
    'Ubuntu, Inter, Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue"',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    lineHeight: 48 / 38,
    fontWeight: 700,
  },
  h2: {
    fontWeight: 700,
  },
  h3: {
    lineHeight: 30 / 24,
    fontWeight: 700,
  },
  h4: {
    fontWeight: 700,
  },
  h5: {
    lineHeight: 22 / 18,
    fontWeight: 700,
  },
  h6: {
    fontWeight: 700,
  },
  subtitle1: {
    lineHeight: 28 / 16,
    fontWeight: 500,
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 17 / 14,
  },
  body1: {
  },
  body2: {
    // fontSize: pxToRem(14),
    fontWeight: 400,
  },
  caption: {
  },
  overline: {
    // fontSize: pxToRem(12),
    textTransform: "uppercase",
    lineHeight: 1,
  },
  button: {
    textTransform: "capitalize",
  },
};

export default typography;
